
import searchBox from './SearchBoxReducer';


export default searchBox;
